<template>
  <div class="index">
    <div style="display: flex;justify-content: space-between">
      <div class="commonCss">
        <myToDo ref="myToDo"/>
        <saleReport ref="saleReport"/>
        <customerForgetRemind ref="customerForgetRemind"/>
      </div>
      <div class="commonCss">
        <contractAmountCondition ref="contractAmountCondition"/>
        <addCustomerCondition ref="addCustomerCondition"/>
      </div>
    </div>
  </div>
</template>

<script>
import myToDo from "@/views/index/comp/myToDo";
import saleReport from "@/views/index/comp/saleReport"
import addCustomerCondition from "@/views/index/comp/addCustomerCondition";
import contractAmountCondition from "@/views/index/comp/contractAmountCondition";
import customerForgetRemind from "@/views/index/comp/customerForgetRemind";

export default {
  data() {
    return {}
  },
  mounted() {
    this.screenResize();
  },
  methods: {
    screenResize() {
      window.onresize = () => {
        this.$refs.addCustomerCondition && this.$refs.addCustomerCondition.myChart.resize();
        this.$refs.contractAmountCondition && this.$refs.contractAmountCondition.myChart.resize();
      }
    }
  },
  components: {
    myToDo,
    saleReport,
    addCustomerCondition,
    contractAmountCondition,
    customerForgetRemind
  }
}
</script>

<style scoped lang="scss">
.index {
  display: flex;
  flex-direction: column;
  overflow-y: auto !important;
  background: #FAFAFA !important;

  .commonCss {
    width: 49.5%;
    display: flex;
    flex-direction: column;
  }

  * {
    user-select: none;
  }

  ::v-deep *, :after, :before {
    box-sizing: unset;
  }
}
</style>
